import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private _permissions$ = new BehaviorSubject<string[]>([]);

  setPermissions(organizations: { [key: string]: { roles: string[] } }) {
    /**
     * Even tho there can be multiple organizations, we only use permissions from the first one
     * BE assured us that this is the wey
     */
    this._permissions$.next(Object.values(organizations)[0].roles);
  }

  checkPermission$(permission: string): Observable<boolean> {
    return this._permissions$.pipe(
      switchMap(() => of(this.checkPermission(permission)))
    );
  }

  checkEveryPermission$(permissions: string[]): Observable<boolean> {
    return this._permissions$.pipe(
      switchMap(() => of(this.checkEveryPermissions(permissions)))
    );
  }

  checkSomePermissions$(permissions: string[]): Observable<boolean> {
    return this._permissions$.pipe(
      switchMap(() => of(this.checkSomePermissions(permissions)))
    );
  }

  checkSingleOrEveryPermission$(
    permissions: string | string[]
  ): Observable<boolean> {
    return this._permissions$.pipe(
      switchMap(() => of(this.checkSingleOrEveryPermission(permissions)))
    );
  }

  checkPermission(permission: string): boolean {
    return this._permissions$.value.includes(permission);
  }

  checkEveryPermissions(permissions: string[]): boolean {
    return permissions.every((permission) =>
      this._permissions$.value.includes(permission)
    );
  }

  checkSomePermissions(permissions: string[]): boolean {
    return permissions.some((permission) =>
      this._permissions$.value.includes(permission)
    );
  }

  checkSingleOrEveryPermission(permissions: string | string[]): boolean {
    if (typeof permissions === 'string') {
      return this.checkPermission(permissions);
    } else {
      return this.checkEveryPermissions(permissions);
    }
  }
}
